<script lang="ts" setup>
import items from './privacypolicy.json';

import ContractTerms from '~/components/common/ContractTerms.vue';

const title = 'Privacy Policy';

useSeoMeta({
  title
});
</script>

<template>
  <ContractTerms
    :title="title"
    :items="items"
  />
</template>
